import type { UserType } from "@/types"

export const userData: UserType = {
  id: "1",
  firstName: "Admin",
  lastName: "Bilkent",
  name: "Admin Bilkent",
  password: "Bilkent2026",
  username: "admin",
  role: "Developer",
  avatar: "/images/avatars/male-01.svg",
  background: "",
  status: "ONLINE",
  phoneNumber: "+90 312 290 4000",
  email: "admin@bilkent.edu.tr",
  state: "Ankara",
  country: "Türkiye",
  address: "Üniversiteler Mahallesi Bilkent Üniversitesi Çankaya",
  zipCode: "06800",
  language: "Turkish",
  timeZone: "UTC+03:00",
  currency: "TL",
  organization: "Bilkent Üniversitesi",
  twoFactorAuth: false,
  loginAlerts: true,
  accountReoveryOption: "email",
  connections: 1212,
  followers: 3300,
}
